export default __webpack_public_path__ + "static/insta1@2x-12b21e6ce250365b415f78ec3fce08a1.jpg";